import { useState } from "react";
import { TicketTier } from "../Types/TicketTier";
import PerkComponent from "./PerkComponent";

type TierProps = {
  tier: TicketTier;
};

function TierComponent({ tier }: TierProps) {
  const [perkValues, setPerkValues] = useState<number[]>(
    tier.perks.map(() => 0) // initialize all to 0
  );

  // sum of all perk values
  const totalPerkValue = perkValues.reduce((sum, v) => sum + v, 0);

  // calculation: tier cost minus perk values
  const adjustedCost = totalPerkValue - (tier.cost - tier.previousTierCost);

  function updatePerkValue(index: number, value: number) {
    const newValues = [...perkValues];
    newValues[index] = value;
    setPerkValues(newValues);
  }

  return (
    <div className="tierDiv">
      <form aria-label={`${tier.level} tier value calculator`}>
        <span style={{ textAlign: "left", fontWeight: "bolder" }} title={tier.historicalPricesText}>
          {tier.level} Cost (with fees): {tier.cost}
        </span>
        <br />
        <p className={adjustedCost >= 0 ? "positive" : "negative"}>
            Your Excess Value above {tier.previousTierLevel} cost:  {adjustedCost.toLocaleString("en-US", { style: "currency", currency: "USD" })}</p>
        {tier.perks.map((perk, index) => (
          <PerkComponent
            key={`${tier.level}-${perk.name}-${index}`}
            perk={perk}
            value={perkValues[index]}
            onValueChange={(value) => updatePerkValue(index, value)}
          />
        ))}
      </form>
    </div>
  );
}

export default TierComponent;